import { YPaymentAmount } from '../y/amount';
import { $api } from '../y/api';
import { YId } from '../y/types';
import { CEventId } from './c-event';
import { CVideoId } from './c-event-admin';

interface CVideoWatchResponse {
    can_watch: boolean;
    live: boolean;
    live_in: number;
    master_url: string;
    position: number;
    reason: string;
    can_buy: boolean;
    buy_price: { [country: string]: YPaymentAmount };
}

export function cVideoWatch(event_id: CEventId, video_id: CVideoId) {
    return $api.GET<CVideoWatchResponse>(`event/${event_id}/video/${video_id}/watch`);
}

export function cVideoViewAction(booking_id: YId, action: 'rate', params: { rating: 'up' | 'down' }): Promise<void>;
export function cVideoViewAction(booking_id: YId, action: 'review', params: { text: string }): Promise<void>;
export function cVideoViewAction(video_view_id: YId, action: string, params?: any) {
    return $api.POST(`video_view/${video_view_id}/${action}`, params);
}
